import React from 'react';
import cn from 'classnames';

import styles from './Table.module.sass';
import { Loader } from '../../../components/Loader';
import Row from './Row';
import Checkbox from '../../../components/Checkbox';

// data
import { IUserListItem } from '@types';
import { Paginate } from 'components/Paginate';

interface TableProps {
  className?: string;
  isRequestLoading: boolean;
  users: IUserListItem[];
  pageCount: number;
  handlePageChange: (selectedItem: { selected: number }) => void;
  selectedUsers?: Set<string>;
  onSelectUser?: (userId: string, isSelected: boolean) => void;
  onSelectAll?: () => void;
  allCurrentPageSelected?: boolean;
  someCurrentPageSelected?: boolean;
}

const Table: React.FC<TableProps> = ({ 
  className, 
  users, 
  isRequestLoading, 
  pageCount, 
  handlePageChange,
  selectedUsers = new Set(),
  onSelectUser,
  onSelectAll,
  allCurrentPageSelected = false
}) => {
  return (
    <>
      {isRequestLoading && <Loader />}
      <div className={cn(styles.wrapper, className)}>
        <div className={cn(styles.table)}>
          <div className={cn(styles.row)}>
            <div className={styles.col}>
              {onSelectAll && (
                <Checkbox
                  value={allCurrentPageSelected}
                  onChange={onSelectAll}
                  className={styles.checkbox}
                  classCheckboxTick=""
                  content=""
                  reverse={false}
                />
              )}
            </div>
            <div className={styles.col}>სახელი</div>
            <div className={styles.col}>მეილი</div>
            <div className={styles.col}>ტელ. ნომერი</div>
            <div className={styles.col}>რეიტინგი</div>
          </div>

          {!isRequestLoading && users.map(user => (
            <Row 
              item={user} 
              key={user.id}
              isSelected={selectedUsers.has(user.id)}
              onSelect={onSelectUser ? (isSelected: boolean) => onSelectUser(user.id, isSelected) : undefined}
            />
          ))}
        </div>
        <Paginate pageCount={pageCount} handlePageClick={handlePageChange} />
      </div>
    </>
  );
};

export default Table;
